export default "__VITE_ASSET__7f8f8341__"